import { createFileRoute } from '@tanstack/react-router';
import { DocumentTitle } from '~/components/DocumentTitle';
import { NestedRouteErrorBoundary } from '~/components/errors/NestedRouteErrorBoundary';
import { ResourcesPage } from '~/features/resources/ResourcesPage';

export const Route = createFileRoute('/_auth/_appLayout/resources')({
  component: ResourcesRoute,
  errorComponent: NestedRouteErrorBoundary,
});

function ResourcesRoute() {
  return (
    <>
      <DocumentTitle title="Skills | Versori" />
      <ResourcesPage />
    </>
  );
}
